import { render } from "./SoinsResume.vue?vue&type=template&id=3c2ce2f6"
import script from "./SoinsResume.vue?vue&type=script&lang=js"
export * from "./SoinsResume.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__